import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09c94d8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktop-only" }
const _hoisted_2 = { class: "text-overline" }
const _hoisted_3 = { class: "text-h5 q-my-md title" }
const _hoisted_4 = { class: "mobile-only" }
const _hoisted_5 = { class: "text-overline" }
const _hoisted_6 = { class: "text-h4" }
const _hoisted_7 = { class: "absolute-top btn" }



interface Prop {
  label: string
  imgsrc: string
  title: string
  text: string[]
  toName: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'baseCard',
  props: {
    label: null,
    imgsrc: null,
    title: null,
    text: null,
    toName: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    bordered: "",
    flat: "",
    class: "baseCard"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_card_section, { horizontal: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_img, {
              src: __props.imgsrc,
              class: "col-8",
              width: "40vw"
            }, null, 8, ["src"]),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_q_badge, {
                    color: "grey-10",
                    class: "q-pa-sm",
                    style: {"font-weight":"bold"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.label), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.text, (line) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: line,
                    class: "q-ma-none caption",
                    style: {"width":"100%"}
                  }, _toDisplayString(line), 1))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_img, { src: __props.imgsrc }, null, 8, ["src"]),
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, _toDisplayString(), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.title), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.text, (line) => {
              return (_openBlock(), _createElementBlock("p", {
                key: line,
                class: "q-ma-none caption",
                style: {"width":"100%"}
              }, _toDisplayString(line), 1))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_q_btn, {
          to: `works/${__props.toName}`,
          color: "transparent",
          class: "btn"
        }, null, 8, ["to"])
      ])
    ]),
    _: 1
  }))
}
}

})